// extracted by mini-css-extract-plugin
export default {"updateTemplateSelector":"styles_updateTemplateSelector__9h1Ao","commands":"styles_commands__XyCaK","btn":"styles_btn__T3Ek2"};